import { formValueSelector } from 'redux-form';
export const getTotalPrice = (form, name) => state => Object.values(formValueSelector(form)(state, name) || {}).reduce((totalPrice, value) => totalPrice + ((value === null || value === void 0 ? void 0 : value.priceRaw) || 0), 0);
export const getTotalMarkup = (form, name) => state => Object.values(formValueSelector(form)(state, name) || {}).reduce((totalMarkup, value) => {
  const markup = value === null || value === void 0 ? void 0 : value.markup;
  if (typeof totalMarkup !== 'number') {
    return markup;
  }
  if (typeof markup !== 'number') {
    return totalMarkup;
  }
  return totalMarkup + markup;
}, null);
export const getPriceDivided = (price, divider) => {
  if (divider > 0 && Number.isInteger(divider)) {
    return divider > 1 ? Math.ceil(price / divider) : price;
  }
  return null;
};
//# sourceMappingURL=price.js.map